module.exports = __webpack_public_path__ + "img/pen.6753be5a.svg";